
export type Type = number;
export let Type: any = {};
Type.STRING =  /** @type {?} */(( <any>''));
Type.NUMBER =  /** @type {?} */(( <any>0));
Type.BOOLEAN =  /** @type {?} */(( <any>false));
Type.NULL =  /** @type {?} */(( <any>null));
Type.ARRAY =  /** @type {?} */(( <any>[]));
Type.CLASS =  /** @type {?} */(( <any>true));
Type.CUSTOM =  /** @type {?} */(( <any>1));
Type[Type.STRING] = "STRING";
Type[Type.NUMBER] = "NUMBER";
Type[Type.BOOLEAN] = "BOOLEAN";
Type[Type.NULL] = "NULL";
Type[Type.ARRAY] = "ARRAY";
Type[Type.CLASS] = "CLASS";
Type[Type.CUSTOM] = "CUSTOM";

